module.exports = __webpack_public_path__ + "assets/cc96303f9860fec89cb9a0746e5d850b.png";